import React from 'react';
import { RESUNA } from '../Dispatch/icons';
import StyledToolTip from '../../common/StyledToolTip';

const UnattendedDelivery = ({ color }) => (
  <StyledToolTip title="Unattended Delivery">
    <span>
      <RESUNA color={color} />
    </span>
  </StyledToolTip>
);

export default UnattendedDelivery;
